(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    class LocalizationSelector extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.disclosure = this.querySelector('[data-localization-disclosure]');
      this.searchInput = this.querySelector('[data-localization-search]');
      this.emptyState = this.querySelector('[data-localization-empty]');
      this.countryOptions = [...this.querySelectorAll('[data-localization-option]')];

      for (const flag of this.querySelectorAll('[data-country-flag]')) {
        flag.textContent = this.countryFlag(flag.dataset.countryFlag);
      }

      this.searchInput?.addEventListener('input', () => this.filterCountries(), { signal: this.controller.signal });
      this.disclosure?.addEventListener('toggle', () => {
        if (!this.disclosure.open) return;
        requestAnimationFrame(() => this.searchInput?.focus({ preventScroll: true }));
      }, { signal: this.controller.signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.disclosure?.open) return;
        this.disclosure.removeAttribute('open');
        this.querySelector('[data-localization-trigger]')?.focus();
      }, { signal: this.controller.signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.disclosure?.open || this.contains(event.target)) return;
        this.disclosure.removeAttribute('open');
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    countryFlag(countryCode) {
      if (!countryCode || countryCode.length !== 2) return countryCode || '';
      return [...countryCode.toUpperCase()]
        .map((character) => String.fromCodePoint(127397 + character.charCodeAt(0)))
        .join('');
    }

    filterCountries() {
      const query = this.searchInput?.value.trim().toLocaleLowerCase() || '';
      let visibleCount = 0;

      for (const option of this.countryOptions) {
        const visible = !query || option.dataset.searchValue.includes(query);
        option.closest('[data-localization-item]').hidden = !visible;
        if (visible) visibleCount += 1;
      }

      if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
    }
  }

  if (!customElements.get('localization-selector')) {
    customElements.define('localization-selector', LocalizationSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class QuickAddCard extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.toggleButton = this.querySelector('[data-quick-add-toggle]');
      this.panel = this.querySelector('[data-quick-add-panel]');
      this.status = this.querySelector('[data-quick-add-status]');
      this.label = this.querySelector('[data-quick-add-label]');
      this.cardSku = this.querySelector('[data-product-card-sku]');
      this.cardSkuRow = this.cardSku?.closest('.product-card__sku');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
      this.cardVideo = this.querySelector('[data-card-video]');
      this.videoToggle = this.querySelector('[data-card-video-toggle]');
      this.mediaLink = this.querySelector('.product-card__media');
      this.isLoading = false;
      this.videoRequestId = 0;

      const loadSecondaryImage = () => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        this.loadSecondaryImage();
      };
      this.mediaLink?.addEventListener('pointerenter', loadSecondaryImage, { once: true, signal: this.controller.signal });
      this.mediaLink?.addEventListener('focusin', () => this.loadSecondaryImage(), { once: true, signal: this.controller.signal });
      this.mediaLink?.addEventListener('pointerenter', () => this.playCardVideo(), { signal: this.controller.signal });
      this.mediaLink?.addEventListener('pointerleave', () => this.resetCardVideo(), { signal: this.controller.signal });
      this.mediaLink?.addEventListener('focusin', () => this.playCardVideo(), { signal: this.controller.signal });
      this.mediaLink?.addEventListener('focusout', () => this.resetCardVideo(), { signal: this.controller.signal });
      this.videoToggle?.addEventListener('click', () => this.toggleCardVideo(), { signal: this.controller.signal });

      document.addEventListener('product-card:video-play', (event) => {
        if (event.detail !== this) this.resetCardVideo();
      }, { signal: this.controller.signal });

      if (this.cardVideo && 'IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) this.resetCardVideo();
        }, { threshold: 0.1 });
        this.videoObserver.observe(this);
      }

      this.toggleButton?.addEventListener('click', () => this.toggle(), { signal: this.controller.signal });
      for (const button of this.querySelectorAll('[data-quick-add-variant]')) {
        button.addEventListener('click', () => this.add(button), { signal: this.controller.signal });
      }

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.panel && !this.panel.hidden) {
          this.close();
          this.toggleButton?.focus();
        }
      }, { signal: this.controller.signal });

      document.addEventListener('quick-add:open', (event) => {
        if (event.detail !== this) this.close();
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.resetCardVideo();
      this.videoObserver?.disconnect();
      this.controller?.abort();
    }

    toggle() {
      if (!this.panel || !this.toggleButton) return;
      if (this.panel.hidden) {
        document.dispatchEvent(new CustomEvent('quick-add:open', { detail: this }));
        this.panel.hidden = false;
        this.toggleButton.setAttribute('aria-expanded', 'true');
      } else {
        this.close();
      }
    }

    close() {
      if (!this.panel || !this.toggleButton) return;
      this.panel.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }

    loadSecondaryImage() {
      if (!this.secondaryImage?.dataset.src) return;
      this.secondaryImage.srcset = this.secondaryImage.dataset.srcset;
      this.secondaryImage.src = this.secondaryImage.dataset.src;
      delete this.secondaryImage.dataset.srcset;
      delete this.secondaryImage.dataset.src;
    }

    hydrateCardVideo() {
      if (!this.cardVideo || this.cardVideo.dataset.hydrated === 'true') return;
      for (const source of this.cardVideo.querySelectorAll('source[data-src]')) {
        source.src = source.dataset.src;
        delete source.dataset.src;
      }
      this.cardVideo.dataset.hydrated = 'true';
      this.cardVideo.load();
    }

    async playCardVideo(userInitiated = false) {
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const hasVisibleFocus = this.mediaLink?.matches(':focus-visible');
      if (!this.cardVideo || (!userInitiated && !supportsHover && !hasVisibleFocus)) return;
      if (!userInitiated && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!userInitiated && navigator.connection?.saveData) return;

      const requestId = ++this.videoRequestId;
      this.hydrateCardVideo();

      try {
        await this.cardVideo.play();
        if (requestId !== this.videoRequestId || this.cardVideo.paused) return;
        this.mediaLink?.classList.add('is-video-active');
        this.videoToggle?.setAttribute('aria-pressed', 'true');
        if (this.videoToggle) this.videoToggle.setAttribute('aria-label', this.videoToggle.dataset.pauseLabel);
        document.dispatchEvent(new CustomEvent('product-card:video-play', { detail: this }));
      } catch (error) {
        this.resetCardVideo();
      }
    }

    toggleCardVideo() {
      if (!this.cardVideo) return;
      if (this.cardVideo.paused || !this.mediaLink?.classList.contains('is-video-active')) {
        this.playCardVideo(true);
      } else {
        this.resetCardVideo();
      }
    }

    resetCardVideo() {
      if (!this.cardVideo) return;
      this.videoRequestId += 1;
      this.cardVideo.pause();
      if (this.cardVideo.readyState > 0) this.cardVideo.currentTime = 0;
      this.mediaLink?.classList.remove('is-video-active');
      this.videoToggle?.setAttribute('aria-pressed', 'false');
      if (this.videoToggle) this.videoToggle.setAttribute('aria-label', this.videoToggle.dataset.playLabel);
    }

    async add(button) {
      if (this.isLoading || button.disabled || !button.dataset.quickAddVariant) return;

      this.isLoading = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      this.setStatus('');

      try {
        if (window.muzeCart) {
          const added = await window.muzeCart.add({ items: [{ id: Number(button.dataset.quickAddVariant), quantity: 1 }] }, button);
          if (added) {
            for (const option of this.querySelectorAll('[data-quick-add-variant]')) option.classList.remove('is-added');
            button.classList.add('is-added');
            if (this.label) this.label.textContent = this.dataset.addedLabel;
            if (this.cardSku && button.dataset.variantSku) {
              this.cardSku.textContent = button.dataset.variantSku;
              this.cardSkuRow.hidden = false;
            }
            this.setStatus(button.dataset.addedMessage || this.dataset.addedLabel);
          }
          return;
        }
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.quickAddVariant), quantity: 1 }]
          })
        });

        if (!response.ok) throw new Error('Quick add failed');
        const lineItems = await response.json();
        const cartResponse = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();

        for (const option of this.querySelectorAll('[data-quick-add-variant]')) option.classList.remove('is-added');
        button.classList.add('is-added');
        if (this.label) this.label.textContent = this.dataset.addedLabel;
        if (this.cardSku && button.dataset.variantSku) {
          this.cardSku.textContent = button.dataset.variantSku;
          this.cardSkuRow.hidden = false;
        }
        this.setStatus(button.dataset.addedMessage || this.dataset.addedLabel);
        this.updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, lineItems } }));
      } catch (error) {
        this.setStatus(this.dataset.errorLabel);
      } finally {
        this.isLoading = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (window.muzeCart?.returnFocus === button && !window.muzeCart.dialog.open) button.focus({ preventScroll: true });
      }
    }

    setStatus(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.hidden = !message;
    }

    updateCartCount(itemCount) {
      const cartLink = document.querySelector('.site-header__cart');
      if (!cartLink) return;

      let count = cartLink.querySelector('.site-header__cart-count');
      if (!count && itemCount > 0) {
        count = document.createElement('span');
        count.className = 'site-header__cart-count';
        count.setAttribute('aria-live', 'polite');
        cartLink.append(count);
      }
      if (count) count.textContent = itemCount;
    }
  }

  if (!customElements.get('quick-add-card')) {
    customElements.define('quick-add-card', QuickAddCard);
  }
  } catch(e) { console.error(e); }
})();

})();
